/**
 *
 * @param meters
 * @returns
 */
export function convertFromMetersToKm(meters: number): number {
  const kilometers = (meters / 1000).toFixed(2)
  return Number(kilometers)
}
